import React from 'react';
import './Popup.css';
import Button from '@material-ui/core/Button';
import { countChildrenUnder21, getFamilyPackageInfo } from '../../../utils/familyUtils';

class Popup extends React.Component {

  state = {
    famelyArray: [],
    numLittleChildren: 0,
    dataReady: false
  };

  componentDidMount() {
    if (this.props.remove) {
      this.props.remove();
    }

    const famelyArray = this.props.araayFamely || [];
    const numLittleChildren = countChildrenUnder21(famelyArray)

    this.setState({
      famelyArray,
      numLittleChildren,
      dataReady: true,
    });
  }

  tow1 = () => {
    this.props.PopupHolidays('רגילה', this.props.holidayValue)
    this.props.closePopup()
  }

  tow2 = () => {
    this.props.PopupHolidays('משפחתית', this.props.holidayValue)
    this.props.closePopup()
  }

  render() {
    const { numLittleChildren, dataReady } = this.state;

    if (!dataReady) {
      return null;
    }

    const isFamily = numLittleChildren >= 2;
    const packageType = getFamilyPackageInfo(numLittleChildren)
    const btnText=`רשאי לחבילה ${packageType}`;

    const btnAction = isFamily ? this.tow2 : this.tow1;

    return (
      <div className='GeneralPopup'>
        <div className='backgroundPop'>
          <div className='Pop'>
            <div className="close-button" onClick={this.props.closePopup}>×</div>

            <h2>{this.props.text}</h2>
            <div className="button-container">
              <Button variant="contained" className="btn1" onMouseDown={btnAction}>
                {btnText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Popup;